import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "game" }
const _hoisted_2 = {
  key: 0,
  class: "loading-in-gui"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Loading into game... ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_gui = _resolveComponent("game-gui")!
  const _component_game_lobby = _resolveComponent("game-lobby")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.game)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.game.started)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.loadingGui)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
                  : _createCommentVNode("", true),
                (!_ctx.loadingGui)
                  ? (_openBlock(), _createBlock(_component_game_gui, {
                      key: 1,
                      game: _ctx.game,
                      canvasSrc: _ctx.canvasSrc,
                      clearCanvasKey: _ctx.clearCanvasKey,
                      showingNewRound: _ctx.showingNewRound,
                      showingScores: _ctx.showingScores,
                      onClearCanvas: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearCanvas())),
                      onRestartGame: _cache[1] || (_cache[1] = ($event: any) => (_ctx.restartGame())),
                      onSendCanvasData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendCanvasData($event))),
                      onSendMessage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendMessage($event))),
                      onWordSelected: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectWord($event))),
                      onNoRemainingTime: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nextDrawer())),
                      onShowLetterInterval: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showNewLetter()))
                    }, null, 8, ["game", "canvasSrc", "clearCanvasKey", "showingNewRound", "showingScores"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock(_component_game_lobby, {
                key: 1,
                game: _ctx.game,
                onSendMessage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sendMessage($event))),
                onRoundsUpdate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateRoundsGameInfo($event))),
                onDrawTimeUpdate: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateDrawTimeGameInfo($event))),
                onStartGame: _cache[10] || (_cache[10] = ($event: any) => (_ctx.startGame()))
              }, null, 8, ["game"]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}